<div class="empty">
  <h3 class="title">{{ title() | translate }}</h3>

</div>
